export const ApiEntitySeasons = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async (year, id, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/seasons/${year}`)
    return result.data
  }

  const save = async (id, payload, module = 'accommodations') => {
    const result = await axios.post(`/api/entities/${module}/${id}/seasons/${payload.season.id}`, payload)
    return result.data
  }

  const remove = async (id, payload, module = 'accommodations') => {
    const result = await axios.delete(`/api/entities/${module}/${id}/seasons/${payload.season.id}`)
    return result.data
  }

  const check = async (id, arrival, departure, module = 'accommodations') => {
    const result = await axios.get(`/api/entities/${module}/${id}/seasons/check/${arrival}/${departure}`)
    return result.data
  }

  return {
    entitySeasonsLoad: load,
    entitySeasonsCheck: check,
    entitySeasonsRemove: remove,
    entitySeasonsSave: save
  }
}
